/**
 * Created by Astha on 12/3/2018.
 */
import {
  FlexRemoteRenameArgs,
  FlexRemoteRenameQuery,
  FlexZoomCommandResponse,
  RepoItem
} from "../../../autogenerated/ZoomBridge";
//@flow
export class FlexRemoteRename {

  _newName: string;
  _asset: RepoItem;

  constructor(newName: string, asset: RepoItem) {
    this._asset = asset;
    this._newName = newName;
  }

  run(): Promise<FlexZoomCommandResponse> {
    const query: FlexRemoteRenameQuery = new FlexRemoteRenameQuery();
    const message: FlexRemoteRenameArgs = new FlexRemoteRenameArgs();
    message.setBranch(ThumbnailUtil.HEAD_BRANCH)
      .setLogMsg("Renaming a file")
      .setRemotePath(this._asset.getRemotePath())
      .setNewName(this._newName);
    query.message = message;
    return query.run();
  }
}
